import { combineReducers } from 'redux';
import altStoreReducer from './alts-store';

export default combineReducers({
  store: altStoreReducer,
});
